import { render, staticRenderFns } from "./RenglonajeDetailsModal.vue?vue&type=template&id=3292dbb4&scoped=true&"
import script from "./RenglonajeDetailsModal.vue?vue&type=script&lang=js&"
export * from "./RenglonajeDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./RenglonajeDetailsModal.vue?vue&type=style&index=0&id=3292dbb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3292dbb4",
  null
  
)

export default component.exports